var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenPrevEditor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.363 47.27a5.093 5.093 0 005.09-5.09V26.906h-5.09V42.18H5.816V11.633H21.09v-5.09H5.816a5.093 5.093 0 00-5.09 5.09V42.18a5.093 5.093 0 005.09 5.09zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.727 6.543h9.129L14.198 30.199l3.602 3.598L41.453 10.14v9.129h5.094V1.453h-17.82zm0 0"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48ZyBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZD0iTTM2LjM2MyA0Ny4yN2E1LjA5MyA1LjA5MyAwIDAgMCA1LjA5LTUuMDlWMjYuOTA2aC01LjA5VjQyLjE4SDUuODE2VjExLjYzM0gyMS4wOXYtNS4wOUg1LjgxNmE1LjA5MyA1LjA5MyAwIDAgMC01LjA5IDUuMDlWNDIuMThhNS4wOTMgNS4wOTMgMCAwIDAgNS4wOSA1LjA5em0wIDAiLz48cGF0aCBkPSJNMjguNzI3IDYuNTQzaDkuMTI5TDE0LjE5OCAzMC4xOTlsMy42MDIgMy41OThMNDEuNDUzIDEwLjE0djkuMTI5aDUuMDk0VjEuNDUzaC0xNy44MnptMCAwIi8+PC9nPjwvc3ZnPg==";
export { SvgOpenPrevEditor as ReactComponent };